import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme, _, utils) => ({
  navbar: {
    backgroundColor: theme.colors.backgroundGray[0],
    borderRight: 'none'
  },

  list: {
    gap: 0,
    padding: `0px 0px 0px ${theme.spacing.sm}`,
    [utils.largerThan('md')]: {
      padding: `${theme.spacing.md} ${theme.spacing.sm} 0px ${theme.spacing.sm}`
    }
  }
}));
